import { useTranslation, Trans } from "react-i18next";

const Maps=()=>{
    const { t } = useTranslation();
    return <div className="maps">
        <div className="row m-0">
            <div className="col-md-6 mb-4 mb-md-0 p-0 pe-md-1">
                <div className="map">
                    <div className="circle-marker"></div>
                    <div className="description-marker">
                        <h6>{t('AKAD GATE PHARMACY')}</h6>
                        <h6>{t('FIRST BRANCH')}</h6>
                    </div>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3218.26422765222!2d43.99722932844213!3d36.23307486120464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40071fa59a58b8e7%3A0x37782ad97d6615a7!2zQWthZCBnYXRlIHBoYXJtYWN5L9i12YrYr9mE2YrYqSDYqNmI2KfYqNipINin2YPYrw!5e0!3m2!1sen!2siq!4v1671506401497!5m2!1sen!2siq"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Map showing Akad Gate Pharmacy location"
                    ></iframe>

                </div>
            </div>
            <div className="col-md-6 p-0 ps-md-1">
                <div className="map">
                    <div className="circle-marker"></div>
                    <div className="description-marker">
                        <h6>{t('AKAD GATE PHARMACY')}</h6>
                        <h6>{t('SECOND BRANCH')}</h6>
                    </div>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6436.48464736596!2d43.991623497345884!3d36.23360703028219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40071f556cd5779f%3A0xf34bae640b86faca!2zKGFxd2FzKSBBa2FkLUdhdGUgcGhhcm1hY3kgLyDYtdmK2K_ZhNmK2KkgKNin2YLZiNin2LMpINio2YjYp9io2Kkg2KfZg9iv!5e0!3m2!1sen!2siq!4v1697804315589!5m2!1sen!2siq"
                        width="100%"
                        height="100%"
                        style={{border: 0}}
                        allowFullScreen=""
                        loading="lazy"
                        title="Map showing Akad Gate Pharmacy location"
                        referrerPolicy="no-referrer-when-downgrade"
                    >
                    </iframe>
                </div>
            </div>
        </div>
    </div>
}
export default Maps;